import { render, staticRenderFns } from "./UserStoresTableActions.vue?vue&type=template&id=71a4c72a"
import script from "./UserStoresTableActions.vue?vue&type=script&lang=js"
export * from "./UserStoresTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports